// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"60fd8975cb2ad65e44ad","453":"8de352055c390b389b83","522":"06b52879ac167ec59708"}[chunkId] + ".js";
};